import { Skeleton, styled } from "@mui/material"
import { Fragment, useState } from "react"

const Image = styled("img")(() => ({
  width: "100%",
  height: "auto",
  objectFit: "cover",
}))
function SkeletonImage({ src, alt = "img", sx = {}, ...props }) {
  const [active, setActive] = useState(false)

  return (
    <Fragment>
      {!active &&
        <Skeleton
          variant="rectangular"
          sx={{
            width: "100%",
            height: "100%",
            transform: "none",
            ...sx,
          }}
        />
      }
      <Image
        alt={alt}
        src={src}
        sx={{
          display: active ? "block" : "none",
          ...sx
        }}
        onLoad={() => { setActive(true) }}
        onError={() => { setActive(true) }}
        {...props}
      />
    </Fragment>
  )
}

export default SkeletonImage